module.exports = __webpack_public_path__ + "media/images/creator/monitor/limited-541e6758d50c284737fb0f55e8d8a078.png";